<template>
  <div class="page-content">
    <div class="headings">
      <h2 class="title title-primary">
        {{ $t("lang.movement.order_boxes.page_title_line_1") }}
      </h2>
      <span>|</span>
      <h3 class="title title-primary">
        {{ $t("lang.movement.order_boxes.page_title_line_2") }}
      </h3>
    </div>

    <div class="page-main-content">
      <div class="container-fluid">
        <div class="row" style="margin: 8px">
          <bx-btn @click="$router.back()">{{
            $t("lang.messages.go_back")
          }}</bx-btn>
        </div>
        <v-row class="d-flex d-sm-none">
          <v-list width="100%">
            <v-list-item
              two-line
              v-for="(item, index) in data"
              :key="index"
              class="green lighten-5 ma-2 rounded-lg"
              ripple
              :to="`/inbound/order/${orderId}/gtin/${item.itemType}/detail`"
            >
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.epc }}
                </v-list-item-title>
                <v-list-item-title>
                  {{ item.gtin }}
                </v-list-item-title>
                <v-list-item-title class="text-caption">
                  {{ item.description }}
                </v-list-item-title>
                <v-list-item-title class="text-caption">
                  {{ item.lot }}
                </v-list-item-title>
                <v-list-item-title class="text-caption">
                  {{ item.quantity }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-row>
        <div class="row">
          <bx-box
            :title="
              itemCount + ' ' + $t('lang.box_verifications_report.label_title')
            "
            color="white"
            no-padding
            class="col-12"
            :loading="shouldLoading"
          >
            <template v-slot:default>
              <skeleton-table :columns="10" v-if="shouldLoading" />

              <bx-table
                :data="data"
                :columns="columns"
                paginated
                v-if="!shouldLoading"
                backendPagination
                :currentPage="page"
                :perPage="itemsPerPage"
                :total="itemCount"
                @update:currentPage="updatePage"
              >
                <template slot-scope="props">
                  <bx-table-column>{{ props.row.epc }}</bx-table-column>

                  <bx-table-column>
                    <router-link
                      :to="
                        `/inbound/order/${orderId}/gtin/${props.row.itemType}/detail`
                      "
                      class="bx-link bx-link-bold"
                      >{{ props.row.gtin }}</router-link
                    >
                  </bx-table-column>
                  <bx-table-column>{{ props.row.description }}</bx-table-column>
                  <bx-table-column>{{ props.row.lot }}</bx-table-column>
                  <bx-table-column>{{ props.row.quantity }}</bx-table-column>
                </template>
              </bx-table>
            </template>
          </bx-box>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["orderId", "boxId", "id"],
  data() {
    return {
      shouldLoading: true,
      columns: [],
      data: [],
      orderData: null,
      receptionTime: "",
      waitingTime: "",
      name: "",
      order_status: 0,
      itemCount: 0,
      itemsPerPage: process.env.VUE_APP_GTIN_PER_PAGE,
      page: 1,
      reloadInterval: null
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    updatePage(p) {
      this.page = p;
      this.getData();
    },
    async getData() {
      this.orderData = await this.$api.morders.get(this.orderId);
      this.receptionTime = this.orderData.exit_date;
      this.order_status = this.orderData.destination_status;
      this.waitingTime = this.orderData.waiting_time;
      this.name = this.orderData.order_name;

      let verifications = await this.$api.porders.getVerificationItems(
        this.id,
        {
          offset: (this.page - 1) * this.itemsPerPage,
          limit: this.itemsPerPage
        }
      );
      this.itemCount = verifications.count;

      this.data = verifications.results.map((item, key) => {
        if (item.quantity==0){
          var qty="Nothing"
        }
        else{
          var qty=item.quantity
        }
        return {
          gtin: item.gtin,
          itemType: item.item_type,
          quantity: qty,
          id: item.id,
          lot: item.lot,
          description: item.description,
          epc:item.epc
        };
      });

      this.columns = [
                {
          field: "epc",
          label: "EPC"
        },
        {
          field: "gtin",
          label: this.$t("lang.inbound.order_detail.table_field_1")
        },
        {
          field: "description",
          label: this.$t("lang.inbound.order_detail.description")
        },
        {
          field: "lot",
          label: this.$t("lang.inbound.order_detail.lot")
        },
        {
          field: "quantity",
          label: this.$t("lang.inbound.order_detail.quantity")
        },
      ];
      this.shouldLoading = false;
    }
  }
};
</script>
